_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[14],{

/***/ "2XsZ":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"DesktopTariff_app__TOOPl","__next":"DesktopTariff___next__p8A2t","spacer_h8":"DesktopTariff_spacer_h8__1dLvP","spacer_w8":"DesktopTariff_spacer_w8__3y0y7","spacer_h16":"DesktopTariff_spacer_h16__O5eWB","tariffs_data":"DesktopTariff_tariffs_data__Xw4Zi","tariffs_data__numbers":"DesktopTariff_tariffs_data__numbers__1_c_q","tariffGroupData":"DesktopTariff_tariffGroupData__1rR8I","tariff_group__title":"DesktopTariff_tariff_group__title__3iUJk","tariff_group__row":"DesktopTariff_tariff_group__row__1DlJk","tariff_title__main":"DesktopTariff_tariff_title__main__2SVje","tariffs":"DesktopTariff_tariffs__3y8MG","tariff":"DesktopTariff_tariff__3F26H"};

/***/ }),

/***/ "33D3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Support_app__3Kwq9","__next":"Support___next__1WFaH","spacer_h8":"Support_spacer_h8__2eheZ","spacer_w8":"Support_spacer_w8__u3hVP","spacer_h16":"Support_spacer_h16__147vE","support_data":"Support_support_data__1IEei","support_wrapper":"Support_support_wrapper__146nZ","support_icon":"Support_support_icon__2I-_N","support_icon__top":"Support_support_icon__top__1dRy8","support_icon__bottom":"Support_support_icon__bottom__3jOrJ","support_title":"Support_support_title__2b4Wc","support_subtitle":"Support_support_subtitle__3r2Km"};

/***/ }),

/***/ "4RR6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Cases_app__3sqrF","__next":"Cases___next__3Yl2D","spacer_h8":"Cases_spacer_h8__15Bl0","spacer_w8":"Cases_spacer_w8__2Y9RW","spacer_h16":"Cases_spacer_h16__yFSDQ","cases":"Cases_cases__2UJ3h","cases_title":"Cases_cases_title__3zNF4"};

/***/ }),

/***/ "5DNw":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"SmallNavigation_app__29r7n","__next":"SmallNavigation___next__1BYMx","spacer_h8":"SmallNavigation_spacer_h8__TNyKO","spacer_w8":"SmallNavigation_spacer_w8__3XT_z","spacer_h16":"SmallNavigation_spacer_h16__1ruYI","nav_wrapper":"SmallNavigation_nav_wrapper__3bX3v","nav":"SmallNavigation_nav__1Qy2m","link":"SmallNavigation_link__2C7vM"};

/***/ }),

/***/ "ECGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vcXL");
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2__);




function getLocale(ctx) {
  return true ? process.env.NODE_BUILD_LOCALE : undefined;
}

function decimalAdjust(type, value, exp) {
  // Если степень не определена, либо равна нулю...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }

  value = +value;
  exp = +exp; // Если значение не является числом, либо степень не является целым числом...

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  } // Сдвиг разрядов


  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp))); // Обратный сдвиг

  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
}

function fetchData(_x) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(locale) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(locale === 'ru-RU')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/WJMDc6wAv7mot7ciay+7xA/data/5fd68bdf2e4e096d61bf41b9'));

          case 4:
            return _context.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/WJMDc6wAv7mot7ciay+7xA/data/5fd68be92e4e096d61bf41ba'));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchData.apply(this, arguments);
}

function fetchMainData(_x2) {
  return _fetchMainData.apply(this, arguments);
}

function _fetchMainData() {
  _fetchMainData = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(locale) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(locale === 'ru-RU')) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/WJMDc6wAv7mot7ciay+7xA/data/5fd68bdf2e4e096d61bf41b9'));

          case 4:
            return _context2.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/WJMDc6wAv7mot7ciay+7xA/data/5fd68be92e4e096d61bf41ba'));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchMainData.apply(this, arguments);
}

function fetchTerm(_x3) {
  return _fetchTerm.apply(this, arguments);
}

function _fetchTerm() {
  _fetchTerm = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(locale) {
    var response, json;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (!(locale === 'ru-RU')) {
              _context3.next = 7;
              break;
            }

            _context3.next = 4;
            return isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/r31dRmxKxM+pqXWbdwmqzw/data/5fda55c89794e162c57ace9d');

          case 4:
            response = _context3.sent;
            _context3.next = 10;
            break;

          case 7:
            _context3.next = 9;
            return isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/r31dRmxKxM+pqXWbdwmqzw/data/5fe674fa9794e162c57acebc');

          case 9:
            response = _context3.sent;

          case 10:
            if (response.ok) {
              _context3.next = 12;
              break;
            }

            throw Error(response.statusText);

          case 12:
            _context3.next = 14;
            return response.json();

          case 14:
            json = _context3.sent;
            return _context3.abrupt("return", json.value);

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](0);
            console.log('fetch error' + _context3.t0.message);
            return _context3.abrupt("return", {
              title: '',
              body: '',
              lang: ''
            });

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 18]]);
  }));
  return _fetchTerm.apply(this, arguments);
}

function fetchPolicy(_x4) {
  return _fetchPolicy.apply(this, arguments);
}

function _fetchPolicy() {
  _fetchPolicy = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee4(locale) {
    var response, json;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (!(locale === 'ru-RU')) {
              _context4.next = 7;
              break;
            }

            _context4.next = 4;
            return isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/r31dRmxKxM+pqXWbdwmqzw/data/5fda6f439794e162c57ace9e');

          case 4:
            response = _context4.sent;
            _context4.next = 10;
            break;

          case 7:
            _context4.next = 9;
            return isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()('https://my.bundle.space/api/public/models/r31dRmxKxM+pqXWbdwmqzw/data/5fda6f439794e162c57ace9e');

          case 9:
            response = _context4.sent;

          case 10:
            if (response.ok) {
              _context4.next = 12;
              break;
            }

            throw Error(response.statusText);

          case 12:
            _context4.next = 14;
            return response.json();

          case 14:
            json = _context4.sent;
            return _context4.abrupt("return", json.value);

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](0);
            console.log('fetch error' + _context4.t0.message);
            return _context4.abrupt("return", {
              title: '',
              body: '',
              lang: ''
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 18]]);
  }));
  return _fetchPolicy.apply(this, arguments);
}

var langs = {
  'ru-RU': 'ru',
  'en-US': 'en',
  undefined: 'en'
};

function fetchDocCategories(_x5) {
  return _fetchDocCategories.apply(this, arguments);
}

function _fetchDocCategories() {
  _fetchDocCategories = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee5(locale) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            console.log('locale', locale);
            console.log('langs[locale]', langs[locale]);
            return _context5.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()("https://my.bundle.space/api/public/models/TQQU06RHOv709XIiNy5l4g/data?filter=lang&lang=".concat(langs[locale])));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchDocCategories.apply(this, arguments);
}

function fetchDocs(_x6) {
  return _fetchDocs.apply(this, arguments);
}

function _fetchDocs() {
  _fetchDocs = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee6(locale) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()("https://my.bundle.space/api/public/models/CnRo6haMY+oyhxtj7rFfvQ/data?filter=lang&lang=".concat(langs[locale])));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchDocs.apply(this, arguments);
}

function fetchAllDocs() {
  return _fetchAllDocs.apply(this, arguments);
}

function _fetchAllDocs() {
  _fetchAllDocs = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee7() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()("https://my.bundle.space/api/public/models/CnRo6haMY+oyhxtj7rFfvQ/data"));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fetchAllDocs.apply(this, arguments);
}

function fetchDocById(_x7) {
  return _fetchDocById.apply(this, arguments);
}

function _fetchDocById() {
  _fetchDocById = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee8(id) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_2___default()("https://my.bundle.space/api/public/models/CnRo6haMY+oyhxtj7rFfvQ/data/".concat(id)));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchDocById.apply(this, arguments);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchDocCategories: fetchDocCategories,
  fetchDocs: fetchDocs,
  fetchAllDocs: fetchAllDocs,
  fetchDocById: fetchDocById,
  fetchData: fetchData,
  decimalAdjust: decimalAdjust,
  getLocale: getLocale,
  fetchMainData: fetchMainData,
  fetchTerm: fetchTerm,
  fetchPolicy: fetchPolicy
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("8oxB")))

/***/ }),

/***/ "Eg97":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"MobileTariff_app__3LgC7","__next":"MobileTariff___next__1bCo4","spacer_h8":"MobileTariff_spacer_h8__2Sbjr","spacer_w8":"MobileTariff_spacer_w8__32fYE","spacer_h16":"MobileTariff_spacer_h16__RUPvZ","tariffs":"MobileTariff_tariffs__2h7_A","tariff":"MobileTariff_tariff__3SMao","t_title":"MobileTariff_t_title__JTwyA","t_description":"MobileTariff_t_description__Rx4FI","t_info":"MobileTariff_t_info__1LYN-","t_info__data":"MobileTariff_t_info__data__8qbQN","t_price":"MobileTariff_t_price__29EIH","t_btn":"MobileTariff_t_btn__9xgyc"};

/***/ }),

/***/ "FEhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("y0xf");
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var PrimaryButton = function PrimaryButton(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      name = _ref.name,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '7px 16px' : _ref$padding;
  return __jsx("button", {
    style: {
      padding: padding
    },
    onClick: onClick,
    className: _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default.a.button
  }, name);
};

/* harmony default export */ __webpack_exports__["a"] = (PrimaryButton);

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "RBxI":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Tariffs_app__2-agX","__next":"Tariffs___next__2tOSF","spacer_h8":"Tariffs_spacer_h8__Oo1eO","spacer_w8":"Tariffs_spacer_w8__cXO0G","spacer_h16":"Tariffs_spacer_h16__20bAT","tariffs":"Tariffs_tariffs__3VJjU","mobile_tariff_title":"Tariffs_mobile_tariff_title__1jeZX","switcher":"Tariffs_switcher__KSUhm","switcher_title":"Tariffs_switcher_title__1eObh","switcher_list":"Tariffs_switcher_list__3qC5h","switcher_element":"Tariffs_switcher_element__2Zha7","checked":"Tariffs_checked__27q4d","tariffs_data":"Tariffs_tariffs_data__JPT_S","tariffs_data__numbers":"Tariffs_tariffs_data__numbers__2ZGU6","tariffGroupData":"Tariffs_tariffGroupData__3dAhn","tariff_group__title":"Tariffs_tariff_group__title__3IBzU","tariff_group__row":"Tariffs_tariff_group__row__2KHNn","tariff_title__main":"Tariffs_tariff_title__main__2QfZw"};

/***/ }),

/***/ "RNiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return /* binding */ __N_SSG; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ Home; });

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./containers/Header/index.jsx + 2 modules
var Header = __webpack_require__("eKI5");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./containers/Main/index.module.scss
var index_module = __webpack_require__("ZW8G");
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);

// EXTERNAL MODULE: ./components/PrimaryButton/index.jsx
var PrimaryButton = __webpack_require__("FEhb");

// EXTERNAL MODULE: ./components/Property/index.module.scss
var Property_index_module = __webpack_require__("lUIa");
var Property_index_module_default = /*#__PURE__*/__webpack_require__.n(Property_index_module);

// CONCATENATED MODULE: ./components/Property/index.jsx

var __jsx = react_default.a.createElement;


var Property_Property = function Property(_ref) {
  var title = _ref.title,
      data = _ref.data,
      icon = _ref.icon;
  return __jsx("div", {
    className: Property_index_module_default.a.property
  }, __jsx("div", {
    className: Property_index_module_default.a.property_icon,
    style: {
      backgroundImage: "url(".concat(icon, ")")
    }
  }), __jsx("div", null, __jsx("div", {
    className: Property_index_module_default.a.property_title
  }, title), __jsx("div", {
    className: Property_index_module_default.a.property_data
  }, data)));
};

/* harmony default export */ var components_Property = (Property_Property);
// CONCATENATED MODULE: ./containers/Main/index.jsx

var Main_jsx = react_default.a.createElement;




var Main_Main = function Main(_ref) {
  var properties = _ref.properties,
      data = _ref.data;

  function goToBundle() {
    window.open('https://my.bundle.space/sign-up');
  }

  return Main_jsx("main", {
    className: "".concat(index_module_default.a.main, " wrapper")
  }, Main_jsx("div", {
    className: "".concat(index_module_default.a.main_data, " maxWidth")
  }, Main_jsx("article", {
    className: index_module_default.a.main_article
  }, Main_jsx("h1", {
    className: index_module_default.a.main_title
  }, data.mainTitle), Main_jsx("div", {
    className: index_module_default.a.main_description
  }, data.subTitle), Main_jsx("div", null, Main_jsx(PrimaryButton["a" /* default */], {
    onClick: goToBundle,
    name: data.titleBtn,
    padding: '15px 28px'
  }))), Main_jsx("div", {
    className: index_module_default.a.props
  }, Main_jsx("h2", {
    className: index_module_default.a.props_title
  }, data.propTitle), Main_jsx("div", {
    className: index_module_default.a.props_data
  }, properties && properties.length ? properties.map(function (property) {
    var title = property.value.title;
    var text = property.value.text;
    var icon = property.value.icon[0].URI;
    return Main_jsx(components_Property, {
      key: property.id,
      title: title,
      data: text,
      icon: icon
    });
  }) : null))));
};

/* harmony default export */ var containers_Main = (Main_Main);
// EXTERNAL MODULE: ./containers/Cases/index.module.scss
var Cases_index_module = __webpack_require__("4RR6");
var Cases_index_module_default = /*#__PURE__*/__webpack_require__.n(Cases_index_module);

// EXTERNAL MODULE: ./components/Case/index.module.scss
var Case_index_module = __webpack_require__("SKji");
var Case_index_module_default = /*#__PURE__*/__webpack_require__.n(Case_index_module);

// CONCATENATED MODULE: ./components/Case/index.jsx
var Case_jsx = react_default.a.createElement;



var Case_Case = function Case(_ref) {
  var title = _ref.title,
      description = _ref.description,
      _ref$offer = _ref.offer,
      offer = _ref$offer === void 0 ? '' : _ref$offer,
      images = _ref.images;
  return Case_jsx("div", {
    className: Case_index_module_default.a["case"]
  }, Case_jsx("div", {
    className: Case_index_module_default.a.case_title
  }, title), Case_jsx("div", {
    className: Case_index_module_default.a.case_description
  }, description, Case_jsx("div", {
    className: Case_index_module_default.a.case_offer
  }, offer)), Case_jsx("div", {
    className: Case_index_module_default.a.case_wrapper
  }, images && images.length ? images.map(function (image) {
    return Case_jsx("div", {
      key: image.id,
      className: Case_index_module_default.a.case_example
    }, Case_jsx("img", {
      key: image.id,
      className: Case_index_module_default.a.img,
      src: image.URI,
      alt: "screenshot"
    }));
  }) : null));
};

/* harmony default export */ var components_Case = (Case_Case);
// CONCATENATED MODULE: ./containers/Cases/index.jsx

var Cases_jsx = react_default.a.createElement;



var Cases_Cases = function Cases(_ref) {
  var cases = _ref.cases,
      title = _ref.title;
  return Cases_jsx("section", {
    id: "cases",
    className: "".concat(Cases_index_module_default.a.cases, " wrapper")
  }, Cases_jsx("div", {
    className: "maxWidth"
  }, Cases_jsx("h2", {
    className: Cases_index_module_default.a.cases_title
  }, title), cases && cases.length ? cases.map(function (example) {
    var title = example.value.title;
    var description = example.value.description || '';
    var subDescription = example.value.sub_description || '';
    var images = example.value.example_icon || [];
    return Cases_jsx(components_Case, {
      key: example.id,
      title: title,
      description: description,
      offer: subDescription,
      images: images
    });
  }) : null));
};

/* harmony default export */ var containers_Cases = (Cases_Cases);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./containers/Tariffs/index.module.scss
var Tariffs_index_module = __webpack_require__("RBxI");
var Tariffs_index_module_default = /*#__PURE__*/__webpack_require__.n(Tariffs_index_module);

// EXTERNAL MODULE: ./components/MobileTariff/index.module.scss
var MobileTariff_index_module = __webpack_require__("Eg97");
var MobileTariff_index_module_default = /*#__PURE__*/__webpack_require__.n(MobileTariff_index_module);

// CONCATENATED MODULE: ./components/MobileTariff/index.jsx

var MobileTariff_jsx = react_default.a.createElement;


var MobileTariff_MobileTariff = function MobileTariff(_ref) {
  var prices = _ref.prices,
      titles = _ref.titles;
  return MobileTariff_jsx("div", {
    className: "".concat(MobileTariff_index_module_default.a.tariffs, " maxWidth")
  }, prices && prices.length ? prices.map(function (tariff, idx) {
    return MobileTariff_jsx("div", {
      key: tariff.id,
      className: MobileTariff_index_module_default.a.tariff,
      style: !idx ? {
        backgroundColor: '#FFFFFF'
      } : {
        backgroundColor: "rgba(24, 144, 255, .".concat(idx * 15, ")")
      }
    }, MobileTariff_jsx("div", {
      className: MobileTariff_index_module_default.a.t_title
    }, tariff.name), MobileTariff_jsx("div", {
      className: MobileTariff_index_module_default.a.t_description
    }, tariff.description), MobileTariff_jsx("div", {
      className: MobileTariff_index_module_default.a.t_price
    }, tariff[tariff.showPrice]), MobileTariff_jsx("div", {
      style: {
        marginBottom: '16px'
      },
      className: MobileTariff_index_module_default.a.t_description
    }, titles.duration), MobileTariff_jsx("div", {
      style: {
        width: '100%'
      }
    }, Object.keys(tariff.counters).map(function (counter) {
      return MobileTariff_jsx("div", {
        key: "".concat(tariff.id).concat(counter),
        className: MobileTariff_index_module_default.a.t_info
      }, MobileTariff_jsx("div", null, titles.counters.value[counter], ": "), MobileTariff_jsx("div", {
        className: MobileTariff_index_module_default.a.t_info__data
      }, tariff.counters[counter]));
    }), Object.keys(tariff.flags).map(function (flag) {
      return MobileTariff_jsx("div", {
        key: "".concat(tariff.id).concat(flag),
        className: MobileTariff_index_module_default.a.t_info
      }, MobileTariff_jsx("div", null, titles.flags.value[flag], ": "), MobileTariff_jsx("div", {
        className: MobileTariff_index_module_default.a.t_info__data
      }, tariff.flags[flag] ? MobileTariff_jsx("span", {
        style: {
          color: 'green'
        }
      }, "\u2714") : MobileTariff_jsx("span", {
        style: {
          color: 'darkred'
        }
      }, "\u2718")));
    }), Object.keys(tariff.staticValues).map(function (staticValue) {
      return MobileTariff_jsx("div", {
        key: "".concat(tariff.id).concat(staticValue),
        className: MobileTariff_index_module_default.a.t_info
      }, MobileTariff_jsx("div", null, titles.staticValues.value[staticValue], ": "), MobileTariff_jsx("div", {
        className: MobileTariff_index_module_default.a.t_info__data
      }, tariff.staticValues[staticValue]));
    })));
  }) : null);
};

/* harmony default export */ var components_MobileTariff = (MobileTariff_MobileTariff);
// EXTERNAL MODULE: ./components/DesktopTariff/index.module.scss
var DesktopTariff_index_module = __webpack_require__("2XsZ");
var DesktopTariff_index_module_default = /*#__PURE__*/__webpack_require__.n(DesktopTariff_index_module);

// EXTERNAL MODULE: ./components/TariffHeader/index.module.scss
var TariffHeader_index_module = __webpack_require__("yiWt");
var TariffHeader_index_module_default = /*#__PURE__*/__webpack_require__.n(TariffHeader_index_module);

// CONCATENATED MODULE: ./components/TariffHeader/index.jsx

var TariffHeader_jsx = react_default.a.createElement;


var TariffHeader_TariffHeader = function TariffHeader(_ref) {
  var name = _ref.name,
      price = _ref.price,
      alpha = _ref.alpha,
      btnText = _ref.btnText,
      duration = _ref.duration;
  return TariffHeader_jsx("div", {
    className: TariffHeader_index_module_default.a.t_header
  }, TariffHeader_jsx("div", {
    className: TariffHeader_index_module_default.a.t_title
  }, name), TariffHeader_jsx("div", {
    style: {
      backgroundColor: alpha
    },
    className: "".concat(TariffHeader_index_module_default.a.t_params, " ").concat(TariffHeader_index_module_default.a.params)
  }, TariffHeader_jsx("div", {
    className: TariffHeader_index_module_default.a.params_price
  }, price), TariffHeader_jsx("div", {
    className: TariffHeader_index_module_default.a.params_duration
  }, duration)));
};

/* harmony default export */ var components_TariffHeader = (TariffHeader_TariffHeader);
// CONCATENATED MODULE: ./components/DesktopTariff/index.jsx
var DesktopTariff_jsx = react_default.a.createElement;




var DesktopTariff_DesktopTariff = function DesktopTariff(_ref) {
  var prices = _ref.prices,
      titles = _ref.titles;
  return DesktopTariff_jsx("div", {
    className: "".concat(DesktopTariff_index_module_default.a.tariff, " maxWidth")
  }, DesktopTariff_jsx("div", {
    className: DesktopTariff_index_module_default.a.tariffs_data
  }, DesktopTariff_jsx("div", {
    className: "".concat(DesktopTariff_index_module_default.a.tariff_group__title, " ").concat(DesktopTariff_index_module_default.a.tariff_title__main)
  }, titles.mainTitle), prices && prices.length ? prices.map(function (price, idx) {
    return DesktopTariff_jsx(components_TariffHeader, {
      key: price.id,
      name: price.name,
      price: price[price.showPrice],
      alpha: !idx ? '#FFFFFF' : "rgba(24, 144, 255, .".concat(idx * 15, ")"),
      duration: titles.duration,
      btnText: titles.btnText
    });
  }) : null), DesktopTariff_jsx("div", {
    className: DesktopTariff_index_module_default.a.tariffs_data__numbers
  }, prices && prices.length ? Object.keys(prices[0].counters).map(function (key) {
    return DesktopTariff_jsx("div", {
      key: key,
      className: DesktopTariff_index_module_default.a.tariffGroupData
    }, DesktopTariff_jsx("div", {
      className: DesktopTariff_index_module_default.a.tariff_group__title
    }, titles.counters.value[key]), prices.map(function (tariff, idx) {
      return DesktopTariff_jsx("div", {
        key: "".concat(tariff.id).concat(key),
        style: !idx ? {
          backgroundColor: '#FFFFFF'
        } : {
          backgroundColor: "rgba(24, 144, 255, .".concat(idx * 15, ")")
        },
        className: DesktopTariff_index_module_default.a.tariff_group__row
      }, tariff.counters[key]);
    }));
  }) : null, prices && prices.length ? Object.keys(prices[0].flags).map(function (key) {
    return DesktopTariff_jsx("div", {
      key: key,
      className: DesktopTariff_index_module_default.a.tariffGroupData
    }, DesktopTariff_jsx("div", {
      className: DesktopTariff_index_module_default.a.tariff_group__title
    }, titles.flags.value[key]), prices.map(function (tariff, idx) {
      return DesktopTariff_jsx("div", {
        key: "".concat(tariff.id).concat(key),
        style: !idx ? {
          backgroundColor: '#FFFFFF'
        } : {
          backgroundColor: "rgba(24, 144, 255, .".concat(idx * 15, ")")
        },
        className: DesktopTariff_index_module_default.a.tariff_group__row
      }, tariff.flags[key] ? DesktopTariff_jsx("span", {
        style: {
          color: 'green'
        }
      }, "\u2714") : DesktopTariff_jsx("span", {
        style: {
          color: 'darkred'
        }
      }, "\u2718"));
    }));
  }) : null, prices && prices.length ? Object.keys(prices[0].staticValues).map(function (key) {
    return DesktopTariff_jsx("div", {
      key: key,
      className: DesktopTariff_index_module_default.a.tariffGroupData
    }, DesktopTariff_jsx("div", {
      className: DesktopTariff_index_module_default.a.tariff_group__title
    }, titles.staticValues.value[key]), prices.map(function (tariff, idx) {
      return DesktopTariff_jsx("div", {
        key: "".concat(tariff.id).concat(key),
        style: !idx ? {
          backgroundColor: '#FFFFFF'
        } : {
          backgroundColor: "rgba(24, 144, 255, .".concat(idx * 15, ")")
        },
        className: DesktopTariff_index_module_default.a.tariff_group__row
      }, tariff.staticValues[key]);
    }));
  }) : null));
};

/* harmony default export */ var components_DesktopTariff = (DesktopTariff_DesktopTariff);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./containers/Tariffs/index.jsx

var Tariffs_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Tariffs_Tariffs = function Tariffs(_ref) {
  var prices = _ref.prices,
      titles = _ref.titles;
  var cur = {
    rub: '₽',
    usd: '$',
    eur: '€'
  };

  var _useState = Object(react["useState"])(prices),
      tariffInfo = _useState[0],
      setTariffInfo = _useState[1];

  function getPrice(key) {
    setTariffInfo(prices.map(function (tariff) {
      var newTariff = _objectSpread({}, tariff);

      if (Object.keys(prices)) {
        newTariff.showPrice = key;
      }

      return newTariff;
    }));
  }

  return Tariffs_jsx("section", {
    style: {
      paddingTop: '48px'
    }
  }, prices && prices.length ? Tariffs_jsx("div", {
    className: Tariffs_index_module_default.a.switcher
  }, Tariffs_jsx("div", {
    className: Tariffs_index_module_default.a.switcher_title
  }, titles.switcherTitle, ":"), Tariffs_jsx("div", {
    className: Tariffs_index_module_default.a.switcher_list
  }, Object.keys(cur).map(function (idx) {
    return Tariffs_jsx("div", {
      className: classnames_default()(Tariffs_index_module_default.a.switcher_element, Object(defineProperty["a" /* default */])({}, Tariffs_index_module_default.a.checked, tariffInfo[0].showPrice === idx)),
      onClick: function onClick() {
        getPrice(idx);
      },
      key: idx
    }, cur[idx]);
  }))) : null, Tariffs_jsx("div", {
    className: Tariffs_index_module_default.a.mobile_tariff_title
  }, titles.mainTitle), Tariffs_jsx("div", {
    id: "tariffs",
    className: "".concat(Tariffs_index_module_default.a.tariffs, " wrapper mobile_hidden")
  }, Tariffs_jsx(components_DesktopTariff, {
    prices: tariffInfo,
    titles: titles
  }), Tariffs_jsx(components_MobileTariff, {
    prices: tariffInfo,
    titles: titles
  })));
};

/* harmony default export */ var containers_Tariffs = (Tariffs_Tariffs);
// EXTERNAL MODULE: ./containers/Support/index.module.scss
var Support_index_module = __webpack_require__("33D3");
var Support_index_module_default = /*#__PURE__*/__webpack_require__.n(Support_index_module);

// CONCATENATED MODULE: ./containers/Support/index.jsx

var Support_jsx = react_default.a.createElement;



var Support_Support = function Support(_ref) {
  var data = _ref.data;
  return Support_jsx("section", {
    id: "support",
    className: "wrapper"
  }, Support_jsx("div", {
    className: "".concat(Support_index_module_default.a.support_data, " maxWidth")
  }, Support_jsx("div", {
    className: Support_index_module_default.a.support_icon
  }, Support_jsx("svg", {
    className: Support_index_module_default.a.support_icon__top,
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Support_jsx("path", {
    d: "M6.74461 22.4385L0.653076 27.3469V1.40241C0.653076 1.03047 0.797135 0.673758 1.05356 0.410755C1.30999 0.147753 1.65778 0 2.02042 0H26.6327C26.9953 0 27.3431 0.147753 27.5995 0.410755C27.856 0.673758 28 1.03047 28 1.40241V21.0361C28 21.408 27.856 21.7648 27.5995 22.0278C27.3431 22.2908 26.9953 22.4385 26.6327 22.4385H6.74461ZM3.38777 21.576L5.7984 19.6337H25.2653V2.80481H3.38777V21.576ZM14.3512 16.4082L9.75824 11.6961C9.18128 11.1043 8.85714 10.3017 8.85714 9.46485C8.85714 9.05047 8.93672 8.64015 9.09133 8.25731C9.24594 7.87448 9.47256 7.52663 9.75824 7.23362C10.0439 6.94061 10.3831 6.70818 10.7563 6.5496C11.1296 6.39103 11.5297 6.30941 11.9337 6.30941C12.7496 6.30941 13.5322 6.64186 14.1091 7.23362L14.3512 7.48184L14.5932 7.23362C14.8789 6.94061 15.218 6.70818 15.5913 6.5496C15.9645 6.39103 16.3646 6.30941 16.7686 6.30941C17.1726 6.30941 17.5727 6.39103 17.946 6.5496C18.3192 6.70818 18.6584 6.94061 18.9441 7.23362C19.2298 7.52663 19.4564 7.87448 19.611 8.25731C19.7656 8.64015 19.8452 9.05047 19.8452 9.46485C19.8452 9.87922 19.7656 10.2895 19.611 10.6724C19.4564 11.0552 19.2298 11.4031 18.9441 11.6961L14.3498 16.4068L14.3512 16.4082Z",
    fill: "#1890FF"
  })), Support_jsx("svg", {
    className: Support_index_module_default.a.support_icon__bottom,
    width: "43",
    height: "45",
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Support_jsx("path", {
    d: "M42.3878 32.0154C42.3868 34.8836 41.3961 37.6656 39.5796 39.9006C37.7631 42.1357 35.2298 43.6899 32.3991 44.3059L31.0469 40.2915C32.2851 40.0897 33.4627 39.6186 34.4947 38.9121C35.5268 38.2056 36.3876 37.2813 37.0151 36.2059H31.7908C30.6666 36.2059 29.5885 35.7639 28.7936 34.9773C27.9986 34.1906 27.552 33.1237 27.552 32.0112V23.6217C27.552 22.5092 27.9986 21.4423 28.7936 20.6556C29.5885 19.869 30.6666 19.427 31.7908 19.427H38.0176C37.5004 15.3726 35.5059 11.6443 32.4085 8.94164C29.311 6.23898 25.3234 4.74776 21.1939 4.74776C17.0644 4.74776 13.0768 6.23898 9.97929 8.94164C6.88182 11.6443 4.88737 15.3726 4.37018 19.427H10.5969C11.7211 19.427 12.7993 19.869 13.5942 20.6556C14.3891 21.4423 14.8357 22.5092 14.8357 23.6217V32.0112C14.8357 33.1237 14.3891 34.1906 13.5942 34.9773C12.7993 35.7639 11.7211 36.2059 10.5969 36.2059H4.23878C3.11458 36.2059 2.03643 35.7639 1.24151 34.9773C0.446584 34.1906 0 33.1237 0 32.0112V21.5244C0 9.94066 9.4885 0.550781 21.1939 0.550781C32.8993 0.550781 42.3878 9.94066 42.3878 21.5244V32.0154ZM38.149 32.0112V23.6217H31.7908V32.0112H38.149ZM4.23878 23.6217V32.0112H10.5969V23.6217H4.23878Z",
    fill: "#1890FF"
  }))), Support_jsx("div", {
    className: Support_index_module_default.a.support_title
  }, data.description), Support_jsx("div", {
    className: Support_index_module_default.a.support_subtitle
  }, data.time), Support_jsx(PrimaryButton["a" /* default */], {
    padding: '11px 28px',
    name: data.btnText,
    onClick: function onClick() {
      RocketChat(function () {
        this.maximizeWidget();
      });
    }
  })));
};

/* harmony default export */ var containers_Support = (Support_Support);
// EXTERNAL MODULE: ./containers/Footer/index.jsx
var Footer = __webpack_require__("/d6I");

// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__("ECGM");

// CONCATENATED MODULE: ./pages/index.js

var pages_jsx = react_default.a.createElement;










 // Десятичное округление к ближайшему

if (!Math.round10) {
  Math.round10 = function (value, exp) {
    return helper["a" /* default */].decimalAdjust('round', value, exp);
  };
}

var __N_SSG = true;
function Home(_ref) {
  var prices = _ref.prices,
      properties = _ref.properties,
      cases = _ref.cases,
      support = _ref.support,
      info = _ref.info,
      titles = _ref.titles,
      path = _ref.path;
  return pages_jsx("div", {
    className: "jsx-656774056" + " " + "container"
  }, pages_jsx(head_default.a, null, pages_jsx("title", {
    className: "jsx-656774056"
  }, "Bundle")), pages_jsx(Header["a" /* default */], {
    data: info.value,
    path: path,
    className: "maxWidth"
  }), pages_jsx(containers_Main, {
    properties: properties,
    data: info.value
  }), pages_jsx("div", {
    className: "jsx-656774056" + " " + "divider"
  }, pages_jsx("svg", {
    width: "110%",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1920 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jsx-656774056" + " " + "divider_wave divider_wave__block"
  }, pages_jsx("path", {
    d: "M660.656 32.4966C330.328 -39.7099 161.916 25.5537 0 63.5382V101H1920V63.5382C1814.06 15.833 1665.13 -13.3268 1486.23 9.37182C1307.32 32.0704 1049 117.384 660.656 32.4966Z",
    fill: "#1890FF",
    className: "jsx-656774056"
  })), pages_jsx("svg", {
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1792 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jsx-656774056" + " " + "divider_wave divider_wave__translate"
  }, pages_jsx("path", {
    d: "M671.825 33.1982C365.405 -27.7372 115.47 16.4482 0 58.0344V95H1920V58.0344C1814.06 10.9611 1691.12 -10.0304 1486.23 4.58553C1281.33 19.2015 1061.71 110.732 671.825 33.1982Z",
    fill: "#1890FF",
    fillOpacity: "0.3",
    className: "jsx-656774056"
  }))), pages_jsx(containers_Cases, {
    cases: cases,
    title: info.value.caseTitle
  }), pages_jsx(containers_Tariffs, {
    prices: prices,
    titles: titles.value
  }), pages_jsx(containers_Support, {
    data: support.value
  }), pages_jsx(Footer["a" /* default */], {
    data: info.value,
    path: path
  }), pages_jsx(style_default.a, {
    id: "656774056"
  }, ["@import \"../styles.scss\";", ".divider.jsx-656774056{margin-bottom:-1px;width:100%;position:relative;overflow:hidden;height:auto;}", ".divider_wave.jsx-656774056{height:auto;-webkit-transform:translateX(0px);-ms-transform:translateX(0px);transform:translateX(0px);display:block;}", ".divider_wave__block.jsx-656774056{display:block;}", ".divider_wave__translate.jsx-656774056{-webkit-transform:translateX(8%);-ms-transform:translateX(8%);transform:translateX(8%);position:absolute;left:0;bottom:3px;}", "@media (max-width:976px){.tariffs.jsx-656774056{margin:48px 0 28px 0;}}"]));
}

/***/ }),

/***/ "SKji":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Case_app__3gD7K","__next":"Case___next__1D5Wd","spacer_h8":"Case_spacer_h8__2WwJx","spacer_w8":"Case_spacer_w8__3q0Rl","spacer_h16":"Case_spacer_h16__2B8tp","case":"Case_case__3qaGT","case_title":"Case_case_title__1JWQe","case_description":"Case_case_description__2vthW","case_offer":"Case_case_offer__bEVH3","case_example":"Case_case_example__3cdVB","case_wrapper":"Case_case_wrapper__1BtSl","img":"Case_img__1WsB9"};

/***/ }),

/***/ "ZW8G":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Main_app__1KuXg","__next":"Main___next__m76cy","spacer_h8":"Main_spacer_h8__1LiQm","spacer_w8":"Main_spacer_w8__1YZRO","spacer_h16":"Main_spacer_h16__2rln3","main_data":"Main_main_data__1EXl3","main_article":"Main_main_article__3lSYH","main_title":"Main_main_title__3AIH2","main_description":"Main_main_description__3E-8c","props_title":"Main_props_title__3sMka","props_data":"Main_props_data__2WJvr"};

/***/ }),

/***/ "e619":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Navigation_app__3dp7_","__next":"Navigation___next__1X00M","spacer_h8":"Navigation_spacer_h8__Sb5EC","spacer_w8":"Navigation_spacer_w8__3h-mS","spacer_h16":"Navigation_spacer_h16__1Jw2j","nav":"Navigation_nav__3fFe_","link":"Navigation_link__1yfa9"};

/***/ }),

/***/ "eKI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./containers/Header/index.module.scss
var index_module = __webpack_require__("q6wg");
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);

// EXTERNAL MODULE: ./components/Logo/index.jsx
var Logo = __webpack_require__("b0Xd");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./components/Navigation/index.module.scss
var Navigation_index_module = __webpack_require__("e619");
var Navigation_index_module_default = /*#__PURE__*/__webpack_require__.n(Navigation_index_module);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./components/Navigation/index.jsx
var __jsx = react_default.a.createElement;



var Navigation_Navigation = function Navigation(_ref) {
  var data = _ref.data,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return __jsx("div", {
    className: Navigation_index_module_default.a.nav
  }, __jsx("a", {
    href: "/".concat(path, "#tariffs"),
    className: Navigation_index_module_default.a.link
  }, data.anchorNames[0]), __jsx("a", {
    href: "/".concat(path, "docs"),
    className: Navigation_index_module_default.a.link
  }, data.anchorNames[1]), __jsx("a", {
    href: "/".concat(path, "#cases"),
    className: Navigation_index_module_default.a.link
  }, data.anchorNames[2]), __jsx("a", {
    href: "/".concat(path, "#support"),
    className: Navigation_index_module_default.a.link
  }, data.anchorNames[3]));
};

/* harmony default export */ var components_Navigation = (Navigation_Navigation);
// EXTERNAL MODULE: ./components/SmallNavigation/index.module.scss
var SmallNavigation_index_module = __webpack_require__("5DNw");
var SmallNavigation_index_module_default = /*#__PURE__*/__webpack_require__.n(SmallNavigation_index_module);

// EXTERNAL MODULE: ./components/PrimaryButton/index.jsx
var PrimaryButton = __webpack_require__("FEhb");

// CONCATENATED MODULE: ./components/SmallNavigation/index.jsx

var SmallNavigation_jsx = react_default.a.createElement;



var SmallNavigation_SmallNavigation = function SmallNavigation(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path,
      data = _ref.data;
  return SmallNavigation_jsx("div", {
    className: SmallNavigation_index_module_default.a.nav_wrapper
  }, SmallNavigation_jsx("div", {
    className: SmallNavigation_index_module_default.a.nav
  }, SmallNavigation_jsx("a", {
    href: "/".concat(path, "#tariffs"),
    className: SmallNavigation_index_module_default.a.link
  }, data.anchorNames[0]), SmallNavigation_jsx("a", {
    href: "/".concat(path, "docs"),
    className: SmallNavigation_index_module_default.a.link
  }, data.anchorNames[1]), SmallNavigation_jsx("a", {
    href: "/".concat(path, "#cases"),
    className: SmallNavigation_index_module_default.a.link
  }, data.anchorNames[2]), SmallNavigation_jsx("a", {
    href: "/".concat(path, "#support"),
    className: SmallNavigation_index_module_default.a.link
  }, data.anchorNames[3])), SmallNavigation_jsx("div", null, SmallNavigation_jsx(PrimaryButton["a" /* default */], {
    onClick: onClick,
    name: "Войти"
  })));
};

/* harmony default export */ var components_SmallNavigation = (SmallNavigation_SmallNavigation);
// EXTERNAL MODULE: ./components/PreHeader/index.jsx
var PreHeader = __webpack_require__("+hWi");

// CONCATENATED MODULE: ./containers/Header/index.jsx

var Header_jsx = react_default.a.createElement;









var Header_Header = function Header(_ref) {
  var _classNames;

  var data = _ref.data,
      path = _ref.path;
  var anchrs = Object(react["useRef"])(null);

  function goToBundle() {
    window.open('https://my.bundle.space/sign-up');
  }

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  function showComp() {
    anchrs.current.style.visibility = 'visible';
  }

  return Header_jsx("div", {
    style: {
      width: '100%'
    }
  }, Header_jsx(PreHeader["a" /* default */], {
    title: data.lang
  }), Header_jsx("header", {
    className: "".concat(index_module_default.a.header, " wrapper")
  }, Header_jsx("div", {
    className: "".concat(index_module_default.a.header_data, " maxWidth")
  }, Header_jsx("a", {
    href: "/".concat(path),
    style: {
      textDecoration: 'none'
    }
  }, Header_jsx(Logo["a" /* default */], null)), Header_jsx("div", {
    className: index_module_default.a.menu_btn,
    onClick: function onClick() {
      showComp();
      setIsVisible(!isVisible);
    }
  }, "\u2261"), Header_jsx("div", {
    className: index_module_default.a.header_navigation
  }, Header_jsx(components_Navigation, {
    data: data,
    path: path
  }), Header_jsx("div", {
    className: index_module_default.a.header_btn
  }, Header_jsx(PrimaryButton["a" /* default */], {
    onClick: goToBundle,
    name: data.headerBtn
  }))), Header_jsx("div", {
    ref: anchrs,
    style: {
      visibility: 'hidden'
    },
    className: classnames_default()(index_module_default.a.mobile_header, (_classNames = {}, Object(defineProperty["a" /* default */])(_classNames, index_module_default.a.on, isVisible), Object(defineProperty["a" /* default */])(_classNames, index_module_default.a.off, !isVisible), _classNames))
  }, Header_jsx("button", {
    onClick: function onClick() {
      setIsVisible(false);
    },
    className: index_module_default.a.close_btn
  }, "\u2716"), Header_jsx(components_SmallNavigation, {
    data: data,
    onClick: goToBundle,
    path: path
  })))));
};

/* harmony default export */ var containers_Header = __webpack_exports__["a"] = (Header_Header);

/***/ }),

/***/ "lUIa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Property_app__GwXXX","__next":"Property___next__3K99e","spacer_h8":"Property_spacer_h8__2k21R","spacer_w8":"Property_spacer_w8__3_2jI","spacer_h16":"Property_spacer_h16__FH7gA","property":"Property_property__3uunU","property_icon":"Property_property_icon__2vke7","property_title":"Property_property_title__3IlWf","property_data":"Property_property_data__gMImS"};

/***/ }),

/***/ "q6wg":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"Header_app__3MsCI","__next":"Header___next__3lPqy","spacer_h8":"Header_spacer_h8__w_uAY","spacer_w8":"Header_spacer_w8__28vFn","spacer_h16":"Header_spacer_h16__3xjkC","header":"Header_header__25dya","header_data":"Header_header_data__3VaTw","header_navigation":"Header_header_navigation__2MsW4","header_btn":"Header_header_btn__3OMC6","mobile_header":"Header_mobile_header__39u5M","menu_btn":"Header_menu_btn__3gzrn","off":"Header_off__2eN3q","on":"Header_on__3qHSV","show":"Header_show__2oN61","close_btn":"Header_close_btn__2KLBN"};

/***/ }),

/***/ "vcXL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* globals self */var fetch=self.fetch.bind(self);module.exports=fetch;module.exports.default=module.exports;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "vlRD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RNiq");
      }
    ]);
  

/***/ }),

/***/ "y0xf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"PrimaryButton_app__3vvPk","__next":"PrimaryButton___next__3zK8N","spacer_h8":"PrimaryButton_spacer_h8__2aiUz","spacer_w8":"PrimaryButton_spacer_w8__i1jet","spacer_h16":"PrimaryButton_spacer_h16__2gekZ","button":"PrimaryButton_button__2M-fz"};

/***/ }),

/***/ "yiWt":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"TariffHeader_app__3tiG5","__next":"TariffHeader___next__2Ikbj","spacer_h8":"TariffHeader_spacer_h8__3g7jP","spacer_w8":"TariffHeader_spacer_w8__1Yohc","spacer_h16":"TariffHeader_spacer_h16__1T6wB","t_header":"TariffHeader_t_header__VJvZh","params_btn":"TariffHeader_params_btn__2lwxG","t_title":"TariffHeader_t_title__3aGXk","params":"TariffHeader_params__IHxsV","params_price":"TariffHeader_params_price__21UEn","params_duration":"TariffHeader_params_duration__3obCF"};

/***/ })

},[["vlRD",0,1,3,2,4,5]]]);